import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locale/en.json';

/**
 * English only in this release (plan decision 4). The hook and key discipline stay so Arabic is one more JSON
 * file (`ar.json`) and an entry here; layout already uses logical properties (`border-e`, `ms-auto`).
 */
export const SUPPORTED_LANGUAGES = ['en'] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

export const directionOf = (_language: string): 'ltr' | 'rtl' => 'ltr';

/** Keeps `<html lang>` and `<html dir>` in step with the active language. */
export const applyDocumentLanguage = (language: string): void => {
  document.documentElement.lang = language;
  document.documentElement.dir = directionOf(language);
};

void i18next.use(initReactI18next).init({
  resources: {
    en: { translation: en },
  },
  lng: DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: [...SUPPORTED_LANGUAGES],
  interpolation: { escapeValue: false },
  returnNull: false,
});

applyDocumentLanguage(i18next.language);

export { i18next };
